
import axios from 'axios'
import qs from 'qs'
import router from '@/router'
import Session from '@/utils/session'
import apiHost from './host'

const configure = {
  baseURL: apiHost,
  headers: {
    // App: 'rex',
    Authorization: '9d05b68211be3ecb6e46a96b37e50195'
  },
  paramsSerializer: params => qs.stringify(params)
}

// const apiKey = Session.getSecret()

// if (apiKey) axios.defaults.headers.common.Authorization = apiKey

const api = axios.create(configure)

api.interceptors.response.use(null, (error) => {
  switch (error.response.status) {
    case 500:
      router.push({ name: 'FatalError' })
      break

    case 401:
      router.push({ name: 'Login' })
      Session.destroy()
      break

    default:
      break
  }
  return Promise.reject(error.response)
})

export default api